export const API_ROUTES = {
  masterData: "/api/master/data",
  vehicles: "/api/vehicle/data",
  vehicleById: "/api/vehicles/:id",
  bookingMiscellaneous: "/api/booking/miscellaneous",
  bookingExtraMiscellaneous: "/api/booking/extra-miscellaneous",
  bookingRentalData: "/api/booking/rental/data",
} as const;

export type ApiRouteKey = keyof typeof API_ROUTES;
export type ApiRouteTemplate = (typeof API_ROUTES)[ApiRouteKey];

export type ApiPathParams = Record<string, string | number>;

export type ApiQueryParams = Record<
  string,
  | string
  | number
  | boolean
  | undefined
  | null
  | (string | number)[]
>;

/**
 * Replaces `:param` placeholders in a route template.
 *
 * @example
 * buildApiRoute(API_ROUTES.vehicleById, { id: 42 })
 * // => "/api/vehicles/42"
 */
export function buildApiRoute(
  route: string,
  pathParams?: ApiPathParams,
): string {
  if (!pathParams) {
    return route;
  }

  return Object.entries(pathParams).reduce((path, [key, value]) => {
    const placeholder = `:${key}`;

    if (!path.includes(placeholder)) {
      throw new Error(
        `Missing path parameter "${placeholder}" in route "${path}"`,
      );
    }

    return path.replace(placeholder, encodeURIComponent(String(value)));
  }, route);
}
